import React from 'react';
import Hero from '../components/Hero';
import Story from '../components/Story';
import Gratitude from '../components/Gratitude';
import AboutUs from '../components/AboutUs';
import VisionMission from '../components/VisionMission';
import Philosophy from '../components/Philosophy';
import Services from '../components/Services';
import Commitment from '../components/Commitment';
import Founder from '../components/Founder';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';

const HomePage = () => {
  return (
    <div>
      <Hero />
      <Story />
      <Gratitude />
      <AboutUs />
      <VisionMission />
      <Philosophy />
      <Services />
      <Commitment />
      <Founder />
      <Testimonials />
      <Contact />
    </div>
  );
};

export default HomePage;
